<script>
import ApiService from "../utils/ApiService";

export default {
    name: "UserProfile",
    data() {
        return {
            user: {
                id: '',
                nickname: '',
                avatar: '',
                email: '',
                password: '',
            },
            meta_data: {
                locale: 'zh_CN'
            },
            loading: true,
            showMediaDialog: false,
        }
    },
    methods: {
        onSubmit() {
            let {user} = this;
            if (!user.nickname) {
                this.$message.error(this.$t('user.nickname_required'));
                return false;
            }

            this.loading = true;
            const {nickname, avatar, email, password} = this.user;
            ApiService.post('/features', {
                nickname,
                avatar,
                email,
                password,
                meta_data: this.meta_data
            }).then(response => {
                this.$message.success(this.$t('user.updated'));
            }).catch(reason => {
                this.$message.error(reason.message);
            }).finally(() => {
                this.loading = false;
            });
        },
        onChooseImage(m) {
            this.user.avatar = m.src;
        },
    },
    mounted() {
        ApiService.get('/features').then(response => {
            this.user = {
                ...this.user,
                ...response.data
            }

            this.meta_data = response.data.metas.reduce((acc, cur) => {
                acc[cur.meta_key] = cur.meta_value;
                return acc;
            }, this.meta_data);

        }).catch(reason => {
            this.$message.error(reason.message);
        }).finally(() => {
            this.loading = false;
        });
    }
}
</script>

<template>
    <main-layout>
        <div class="d-flex" slot="header">
            <div class="header-left">
                <h2>Profile</h2>
            </div>
            <div>

            </div>
        </div>

        <section class="page-section" v-loading="loading">
            <el-form label-width="120px" size="medium">
                <el-form-item :label="$t('user.avatar')">
                    <div class="img-60" @click="showMediaDialog=true">
                        <img :src="user.avatar" class="img-60" v-if="user.avatar" alt=""/>
                        <div class="img-60 img-placeholder" v-else></div>
                    </div>
                    <div class="el-form-tips">{{ $t('user.avatar_tips') }}</div>
                </el-form-item>
                <el-form-item :label="$t('user.nickname')">
                    <el-input class="w300" v-model="user.nickname" autocomplete="off"/>
                    <div class="el-form-tips">{{ $t('user.nickname_tips') }}</div>
                </el-form-item>
                <el-form-item :label="$t('user.password')">
                    <el-input class="w300" type="password" v-model="user.password" autocomplete="off"/>
                    <div class="el-form-tips">{{ $t('user.password_tips') }}</div>
                </el-form-item>
                <el-form-item :label="$t('user.email')">
                    <el-input class="w300" v-model="user.email"/>
                    <div class="el-form-tips">{{ $t('user.email_tips') }}</div>
                </el-form-item>
                <el-form-item :label="$t('user.preferred_language')">
                    <el-select v-model="meta_data.locale">
                        <el-option v-for="(v,k) in {'en':'English','zh_CN':'简体中文'}" :key="k" :label="v" :value="k"/>
                    </el-select>
                    <div class="el-form-tips">
                        {{ $t('user.preferred_language_tips') }}
                    </div>
                </el-form-item>
                <el-form-item>
                    <el-button :loading="loading" type="primary" @click="onSubmit">{{ $t('common.submit') }}</el-button>
                </el-form-item>
            </el-form>
        </section>
        <media-dialog v-model="showMediaDialog" :options="{width:500,fit:true,type:'image'}" @confirm="onChooseImage"/>
    </main-layout>
</template>

<style scoped>

</style>